'use strict';

const pagination = require('./pagination');
let focusedElementId;

/**
* Stores the ID of the currently focused element in the document.
* If the focused element has an ID, it assigns it to the global variable `focusedElementId`.
* If the focused element does not have an ID, `focusedElementId` is set to null.
*/
function storeFocusedElement() {
    const $focusedElement = document.activeElement;

    if ($focusedElement) {
        focusedElementId = $focusedElement.id || null;
    }
}

/**
* Restores focus to a previously focused HTML element, if it exists.
*
* This function checks if there is a stored `focusedElementId` and attempts to
* retrieve the corresponding DOM element using `document.getElementById`. If
* the element is found, it sets focus back to this element.
*
* @global
* @returns {void} This function does not return a value.
*/
function restoreFocus() {
    if (focusedElementId) {
        var $elementToFocus = document.getElementById(focusedElementId);

        if ($elementToFocus) {
            $elementToFocus.focus();
        }
    }
}

/**
 * Execute the ajax request that does the price search
 * @param {Integer} pmin Min value for the search
 * @param {Integer} pmax Max value for the search
 */
function priceSearch(pmin, pmax) {
	var refUrl = $('.js-price-slider').data('refurl');

	if (refUrl) {
		var actionUrl = new URL(refUrl, document.location.origin);

		actionUrl.searchParams.set('pmin', pmin);
		actionUrl.searchParams.set('pmax', pmax);

		refUrl = actionUrl.toString();
	}

	$.spinner().start();

	let refUrlWithPagination = pagination.getUrlWithPagination(refUrl);

    storeFocusedElement();

	$.ajax({
		url: refUrlWithPagination.href,
		data: {
			template: $('input[name="fallbackTemplate"]').val(),
			filterUsed: true
		},
		method: 'GET',
		success: function (data) {
			$('.container.search-results').html(data);
			$('body').trigger('search:filter');

			pagination.addQueryToBrowserHistory(refUrlWithPagination, 'applyFilter');

			$.spinner().stop();
			$('.refinement-bar, .modal-background').hide();
            restoreFocus();
		},
		error: function () {
			$.spinner().stop();
			$('.refinement-bar, .modal-background').hide();
		}
	});
}

/**
 * Trigger the 'search:beforeFilter' event if the refinement is not in its default active state
 * @param {jQuery} $element The jQuery element that triggered the event
 */
function changeRefinementState($element) {
    const $changedRefinement = $element.closest('.refinement').find('.js-custom-refinement-btn');

    if (!$changedRefinement.hasClass('default-active')) {
        const refinementID = $changedRefinement.data('target').replace('#refinement-', '');
        $('body').trigger('search:beforeFilter', { changedRefinementID: refinementID, isExpanded: true });
    }
}

module.exports = function () {
	$('#maincontent').on('input', '#lowerPriceRange, #upperPriceRange', function () {
		var $lowerInput = $('#lowerPriceInput');
		var $upperInput = $('#upperPriceInput');
		var $lowerRange = $('#lowerPriceRange');
		var $upperRange = $('#upperPriceRange');

		var lowerVal = parseInt($lowerRange.val(), 10);
		var upperVal = parseInt($upperRange.val(), 10);

		if (upperVal < lowerVal + 15) {
			$lowerRange.val(upperVal - 15);

			if (lowerVal === $lowerRange.min) {
				$upperRange.value = 15;
			}
		}

		if (lowerVal > upperVal - 15) {
			$upperRange.val(lowerVal + 15);

			if (upperVal === $upperRange.max) {
				$lowerRange.value = parseInt($upperRange.max, 10) - 15;
			}
		}

		$upperInput.val(upperVal);
		$lowerInput.val(lowerVal);
	});

	$('#maincontent').on('change', '#lowerPriceRange, #upperPriceRange', function () {
		var $lowerRange = $('#lowerPriceRange');
		var $upperRange = $('#upperPriceRange');

        changeRefinementState($(this));

		priceSearch(parseInt($lowerRange.val(), 10), parseInt($upperRange.val(), 10));
	});

	$('#maincontent').on('change', '#lowerPriceInput, #upperPriceInput', function () {
		var $lowerInput = $('#lowerPriceInput');
		var $upperInput = $('#upperPriceInput');
		var $lowerRange = $('#lowerPriceRange');
		var $upperRange = $('#upperPriceRange');

		var lowerVal = parseInt($lowerInput.val(), 10);
		var upperVal = parseInt($upperInput.val(), 10);

		if (Number.isNaN(lowerVal) || (lowerVal < parseInt($lowerRange.attr('min'), 10)) || (lowerVal > parseInt($upperRange.attr('max'), 10))) {
			lowerVal = parseInt($lowerRange.attr('min'), 10);
		}

		if (Number.isNaN(upperVal) || (upperVal > parseInt($upperRange.attr('max'), 10)) || (upperVal < parseInt($lowerRange.attr('min'), 10))) {
			upperVal = parseInt($upperRange.attr('max'), 10);
		}

        if (lowerVal > upperVal - 15) {
            lowerVal = upperVal - 15;
        } else if (upperVal < lowerVal + 15) {
            upperVal = lowerVal + 15;
        }

        $lowerInput.val(lowerVal);
        $upperInput.val(upperVal);
        $lowerRange.val(lowerVal);
        $upperRange.val(upperVal);

        changeRefinementState($(this));

		priceSearch(lowerVal, upperVal);
	});
};
